import { Navigate } from "react-router-dom";

const roleRoutes = {
    admin: [
        "*", // доступ ко всем
    ],
    manager: [
        "/",
        "/users",
        "/customer",
        "/tarif",
        "/employee",
        "/bonus",
        "/box",
        "/scannerPanel",
        "/scannerPanel/:boxId",
        "/setUser",
        "/setUser/:tcode",
        "/store",
        "/actions",
        "/warehouse/:employeeGuid",
        "/directory",
        "/partial/:type",
        "/partial-detail/:id",
        "/order/:id",
        "/accept-partial",
        "/issue",
        "/rscan",
    ],
    Warehouse: [
        "/scannerPanel",
        "/scannerPanel/:boxId",
        "/order/:id",
        "/rscan",
        "/issue",
        "/box",
        "/partial/:type",
        "/partial-detail/:id",
    ],
};

export const ProtectedRoute = ({ element, path, role }) => {
    const allowedRoutes = roleRoutes[role] || [];
    const isAllowed = allowedRoutes.includes(path) || allowedRoutes.includes("*");

    return isAllowed ? element : <Navigate to="/" replace />;
};
